import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mindmap } from '../../../shared/models/mindmap';
import * as _ from "lodash";
@Component({
  selector: 'app-mindmap',
  templateUrl: './mindmap.component.html',
  styleUrls: ['./mindmap.component.css']
})
export class MindmapComponent implements OnInit {
  @Input() mindMapRenderObject: any;

  @Output() changeEvent: EventEmitter<any> = new EventEmitter();
  mindMapurl;
  mindmapLayer;
  mindMapModel: any;
  constructor() {
    this.mindMapurl = 'assets/mindMap/app/index.html'
  }

  updatedJson: any;

  ngOnInit() {

    document['mindmap'] = this;
  }

  getJson(mindmapupdatedJson) {

    // this.updatedJson = this.mindmapLayer.getJson();

    this.changeEvent.emit(mindmapupdatedJson);

  }

  ngAfterViewInit() {


    setTimeout(() => {
      let bookStructureView: any = document.querySelectorAll('.bookStructureView')[0];
      let iframe: any = bookStructureView.querySelectorAll('iframe')[0];
      let iframeDoc: any = iframe.contentWindow.document;
      this.mindmapLayer = iframeDoc.Layer;

      if (this.mindMapRenderObject.bookDataObj) {

        var dataObj = this.mindMapRenderObject.bookDataObj;


        var mindmapObj = {};

        var mindmapDicObj = {};


        if (this.mindMapRenderObject.componentState == 'CE') {

          for (var i = 0; i < this.mindMapRenderObject.bookDataObj.pages.length; i++) {

            if (i != 0) {
              if (i != this.mindMapRenderObject.bookDataObj.pages.length - 1)
                mindmapDicObj["" + this.mindMapRenderObject.bookDataObj.pages[i]] = this.mindMapRenderObject.bookDataObj[this.mindMapRenderObject.bookDataObj.pages[i]];
            }
          }

        }

        else {
          for (var property in dataObj) {
            if (dataObj[property] != undefined)
              if (dataObj[property].pageNumber) {

                if (dataObj[property].title != "Cover")
                  mindmapDicObj[property] = dataObj[property];
              }
          }
        }

        this.mindMapModel = new Mindmap();
        this.mindMapModel.rootName = this.mindMapRenderObject.title;
        this.mindMapModel.pages = mindmapDicObj;
        this.mindmapLayer.saveJson(this.mindMapModel, 'book', this.mindMapRenderObject.componentState);
      }

      else if (this.mindMapRenderObject.currentPageDataObj) {
        var mindmapDicObj = {};
        mindmapDicObj = this.mindMapRenderObject.currentPageDataObj;

        this.mindMapModel = new Mindmap();
        this.mindMapModel.rootName = 'Page' + this.mindMapRenderObject.currentPageDataObj.pageNumber;
        this.mindMapModel.pages = mindmapDicObj;
        this.mindmapLayer.saveJson(this.mindMapModel, 'page', this.mindMapRenderObject.componentState);

      }


      // mindmapDicObj = dataObj[1];


    }, 1000);

  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/mindmap/mindmap.component.ts